export default __webpack_public_path__ + "map-marker-2.20f9d653a8f80ef11700.png";